import { css } from '@emotion/css';

export const sectionTitleCx = css`
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;

  .title {
    font-weight: 700;
    line-height: 24px;
    color: #13637b;
  }

  .subtitle {
    font-size: 0.75rem;
    line-height: 17px;
    color: #616161;
  }
`;
